import React, { useEffect, useState, useRef } from 'react';
import './style.sass';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { MenuCredito } from 'components/menuCredito';
import { useIsMobile } from 'hooks/useIsMobile';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import ModalLoading from 'components/Loading';
import ValidarCodigo from './validarCodigo.js';
import IngresarNumero from './ingresarNumero.js';
import { decodeStorage } from 'functions/storageBase64';
import { getVerificarPhone, getEnviarOTP } from 'services/verificarCreditoCS';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import IngresarNumeroNew from './ingresarNumero.js';
import ValidarCodigoNew from './validarCodigo.js';
import { PantallaError } from '../MensajesErrores/pantallaError';

let contador = 59;

export default function VerificacionOTPNew() {

    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const session_token = decodeStorage('session_token');
    const EXTERNO = decodeStorage('EXTERNO');

    //variables
    const [numero, setNumero] = useState(false);
    const [keySMS, setKeySMS] = useState(false);
    const [flagActivarContador, setFlagActivarContador] = useState(false);
    const [mostrarPaso2, setMostrarPaso2] = useState(false);

    const [keyEnviado, setKeyEnviado]= useState(false);
    const [numeroEnviado, setNumeroEnviado] = useState(false);

    const [tipoDeRespuestaCredito, setTipoDeRespuestaCredito] = useState(0);
    const [objRespuestaError, setObjRespuestaError] = useState(false);

    // para el contador
    const [tiempo, setTiempo] = useState(contador);
    const [estaVencido, setEstaVencido] = useState(false);
    const [codigoInvalido, setCodigoInvalido] = useState(false); //muestra si el codigo ingresado es valido o no
    const [activarReenvio, setActivarReenvio] = useState(false); // activa desactiva boton de reenvio
    const [mostrarCopy, setMostrarCopy] = useState(false); // muestra copy contrador en boton de reenvio
    let intervalRef = useRef();

    //quitar fixed de incode si usr se regresa
    useEffect(()=>{
        document.getElementsByTagName("body")[0].removeAttribute("style")
    },[])


    const [phone, setPhone] = useState()
    useEffect(() => {
        window.scrollTo(0, 0);
        setLoading(true)
        if(session_token){
            getVerificarPhone(session_token)
            .then(setPhone)
        }
    }, []);
    
    const [phoneOTP, setPhoneOTP] = useState()
    const [preNumero, setPreNumero] = useState(true)
    useEffect(()=> {
        if(phone){
            if(phone.statusCode === 412){
                getEnviarOTP(session_token)
                .then(setPhoneOTP)
                if(document.querySelector(".contenedorOTP")){
                    document.querySelector(".contenedorOTP input").focus()
                    document.querySelector(".contenedorOTP").classList.remove('disabled')
                }
                setPreNumero(false)
            }else if(phone.statusCode === 200){
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
            }
            else{
                setLoading(false)
            }
        }
    },[phone])

    useEffect(()=> {
        if(phoneOTP){
            if(phoneOTP?.data){
                setLoading(false)
                setMostrarPaso2(true)
                setFlagActivarContador(true);
                activarContador();
                setKeySMS(phoneOTP?.data?.data?.key);
                setNumero(phoneOTP?.data?.data?.mobile);
            }
        }
    },[phoneOTP])

    // decrementa de 1 en 1
    const decreaseNum = () => {
        setTiempo((prev) => prev - 1);
    }

    // realiza cuenta regresiva de 60 seg.
    const activarContador = () => {
        setTiempo(contador)
        clearInterval(intervalRef.current)
        intervalRef.current = setInterval(decreaseNum, 1000);
        setEstaVencido(false);
        setCodigoInvalido(false)
        setMostrarCopy(true);
    }

    // detiene el contador
    useEffect(() => {
        if (Number(tiempo) === 0) {
            clearInterval(intervalRef.current);
            setEstaVencido(true);
            setTiempo(contador)
            setActivarReenvio(true);
            setMostrarCopy(false);
        }
        else {
            setActivarReenvio(false);
        }
    }, [tiempo]);

    useEffect((
    )=>{
        // if(keySMS && numero){
            //console.log("ESTE ES EL NUMERO", numero);
            setNumeroEnviado(numero);
            setKeyEnviado(keySMS);
            // console.log("key en padre: ", keySMS)
        // }
    },[keySMS, numero])

    return (
        <>
            {loading && <ModalLoading />}

            {tipoDeRespuestaCredito === 0 ?      
                <div className="homeMobile">
                    {
                        EXTERNO ? null : <HeaderMobileCredito title="Crédito Claroshop" type="backFull" valToken={false} />
                    }
                    <div className="contenedorGeneral homeCverificar">
                        {mostrarPaso2 === false
                            ? <IngresarNumeroNew
                                setMostrarPaso2={setMostrarPaso2}
                                setLoading={setLoading}
                                setFlagActivarContador={setFlagActivarContador} activarContador={activarContador}
                                setNumero={setNumero} setKeySMS={setKeySMS}
                            />
                            : <ValidarCodigoNew
                                setMostrarPaso2={setMostrarPaso2}
                                setLoading={setLoading}
                                flagActivarContador={flagActivarContador}
                                numeroTelefono={numero} keySMS={keySMS}
                                tiempo={tiempo} setTiempo={setTiempo} activarContador={activarContador}
                                activarReenvio={activarReenvio}
                                mostrarCopy={mostrarCopy}
                                estaVencido={estaVencido}
                                preNumero={preNumero}
                                setEstaVencido={setEstaVencido}
                                codigoInvalido={codigoInvalido}
                                setCodigoInvalido={setCodigoInvalido}
                                setTipoDeRespuestaCredito={setTipoDeRespuestaCredito}
                                setObjRespuestaError={setObjRespuestaError}
                                setPhone={setPhone}
                            />
                        }
                    </div>
                </div>
                :null
            }

            {tipoDeRespuestaCredito === 2 && <PantallaError objError={objRespuestaError} />}
        </>
    )
}